export type ReferencedEntity = {
  uuid: string
  name: string
}
export type ReferencedEntityWithIcon = ReferencedEntity & {
  iconUrl?: string
}
export type ReferencedEntityWithBackgroundColor = ReferencedEntity & {
  backgroundColor: string
}
export type ReferencedSprintEntity = ReferencedEntity & {
  num: number
}

export const REFERENCED_ENTITY_SEARCH_LIMIT = 10
